import React, { useEffect, useRef, useState } from "react";
import "./ticket.css";
import TableList from "../../../../Ui/table/TableList";
import SearchContent from "../../../../Ui/table/SearchContent";
import { AssignModal } from "../AssignModal/assignModal";
import TablePagination from "@mui/material/TablePagination";
import TicketServices from "../../../../Services/ticketService";
import axios from "axios";
import CustomToaster from "../../../../Ui/toaster/CustomToaster";
import Cookies from "universal-cookie";
import SimpleBackdrop from "../../../../Ui/Loader/backdrop";
import { useLocation, useNavigate } from "react-router-dom";
import { Logger } from "../../../../Logger/Logger";
import { TextField } from "@mui/material";

const EmpTicketTable = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // console.log("LOCATION",location)
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const cookies = new Cookies();
  const apiKey = cookies.get("UserLogin");
  const isAdmins = cookies.get("adminRole");
  const isSysAdmin = cookies.get("sysAdminRole");
  const [page, setPage] = useState(0);
  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState(-1);
  const [searchKey, setSearchKey] = useState("");
  const [isAdmin, setIsAdmin] = useState(cookies.get("adminRole") === "true");
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [ordering, setOrdering] = useState("");
  const [fullPageData, setFullPageData] = useState(0);
  const [data, setData] = useState([]);
  const [deleteData, setDeleteData] = useState(false);
  const [toaster, setToaster] = useState(false);
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [variant, setVariant] = useState("");
  const [updater, setUpdater] = useState(false);
  const [open, setOpen] = useState(true);
  const [created_date, setCreated_date] = useState("");
  const [inputType, setInputType] = useState("text");
  var today = new Date();
  const maxDate = today.toISOString().substring(0, 10);
  Logger.info("date filter value", created_date);
  // const apiKey =
  //   "eyJhbGciOiJSUzI1NiIsImtpZCI6IjAyYTYxZWZkMmE0NGZjMjE1MTQ4ZDRlZmZjMzRkNmE3YjJhYzI2ZjAiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJhY2NvdW50cy5nb29nbGUuY29tIiwiYXpwIjoiMjM5NjYxNTUwMDExLXNndjdtbW1hbTlnYTRmazY4Y28xYXRramI5bGU1NHQzLmFwcHMuZ29vZ2xldXNlcmNvbnRlbnQuY29tIiwiYXVkIjoiMjM5NjYxNTUwMDExLXNndjdtbW1hbTlnYTRmazY4Y28xYXRramI5bGU1NHQzLmFwcHMuZ29vZ2xldXNlcmNvbnRlbnQuY29tIiwic3ViIjoiMTExMDgzMTEzMTY3MjA3NzMwNjc5IiwiaGQiOiJ3aXNodHJlZXRlY2guY29tIiwiZW1haWwiOiJtdWt1bmQua3Vsa2FybmlAd2lzaHRyZWV0ZWNoLmNvbSIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJhdF9oYXNoIjoiRDBYRnpfZUhrNVRnNzROeEJmOWRLUSIsIm5hbWUiOiJNdWt1bmQgS3Vsa2FybmkiLCJwaWN0dXJlIjoiaHR0cHM6Ly9saDMuZ29vZ2xldXNlcmNvbnRlbnQuY29tL2EvQUVkRlRwN2lMaTl1bk9BVmwweHZQVXl3ei1jaGdBa3BWR0ZIMlVBM3FHMUk9czk2LWMiLCJnaXZlbl9uYW1lIjoiTXVrdW5kIiwiZmFtaWx5X25hbWUiOiJLdWxrYXJuaSIsImxvY2FsZSI6ImVuIiwiaWF0IjoxNjcxODE1ODczLCJleHAiOjE2NzE4MTk0NzMsImp0aSI6Ijk5OWJlM2VhOWZjNTY1OGY5NGZlMWU4N2NlYjIzODg5NGEwZDlmMGMifQ.FuUyhXAjQHVdZXmkI1QdUbu_Lbvf2WbBO6FiQp-X8RdWZlDnxAReVSZUqiQtroaCV2BT3GGPNcXhBCUsI6nc10Ur--aKbXe-gYZNkJ9PNIvj780Y02GsZL1nkyn6YU4MaMv3FRSZLDYJIGDki3L9At4cJUpCRCT8ELu9ZyP4SDnIqRXU7ipT5iTyzbBQztDqcGHqWOUr9khZ--LjUgk4WmmjDW84sij2pha1nVz9Y-exuqvCYw-gyqUkIgrVjpaGeIrM_llFP2smP0xwFF-zWjvKy2MCKGPhruQtG1ZbEdOVgdOsrIMUc5H0sqzgmB7-2DgKl-P29mzvuYoUSI4nmg";

  const queryParams = {
    limit: rowsPerPage,
    page: page + 1,
    search: searchKey,
    ordering: ordering,
    created_date:created_date
  };

  const params = new URLSearchParams(queryParams);

  const getAllTickets = () => {
    if (
      cookies.get("sysAdminRole") == "true" ||
      cookies.get("adminRole") == "true"
    ) {
      axios
        .get(`${BASE_URL}api/ticket/?${params}`, {
          headers: { Authorization: `Bearer ${apiKey}` },
        })
        .then((res) => {
          setData(res.data.data.results);
          setOpen(false);
          setFullPageData(res.data.data._metadata.total_count);
        })
        .catch((error) => {
          if (error.response.status == 403) {
            cookies.remove("UserLogin");
            cookies.remove("UserDetails");
            cookies.remove("adminRole");
            cookies.remove("sysAdminRole");
            cookies.remove("createdBy");
            cookies.remove("UserLoginAccessToken");
            cookies.remove("UserName");
            navigate("/");
          }
          if (error.response.status == 404) {
            navigate("/*");
            setTimeout(() => {
              navigate("/secured/empDashboard");
            }, 5000);
          }
        });
    } else {
      axios
        .get(`${BASE_URL}api/ticket/self_list/?${params}`, {
          headers: { Authorization: `Bearer ${apiKey}` },
        })
        .then((res) => {
          setData(res.data.data.results);
          setOpen(false);
          setFullPageData(res.data.data._metadata.total_count);
        })
        .catch((error) => {
          if (error.response.status == 403) {
            cookies.remove("UserLogin");
            cookies.remove("UserDetails");
            cookies.remove("adminRole");
            cookies.remove("sysAdminRole");
            cookies.remove("createdBy");
            cookies.remove("UserLoginAccessToken");
            cookies.remove("UserName");
            navigate("/");
          }
          if (error.response.status == 404) {
            navigate("/*");
            setTimeout(() => {
              navigate("/secured/empDashboard");
            }, 5000);
          }
        });
    }
  };
  const isFirstRender = React.useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      // if (isFirstRender.current && location?.state?.pageN !== undefined) {
      // console.log("Loccccc", location?.state?.tktId, page, fullPageData)
      // console.log("pgggg", Math.ceil(location?.state?.tktId/rowsPerPage))
      console.log("pageNo", location?.state?.pageN)
      setPage(location?.state?.pageN ?? 0)
      isFirstRender.current = false;
    }
    getAllTickets();
  }, [
    searchKey,
    page,
    rowsPerPage,
    ordering,
    deleteData,
    updater,
    toaster,
    title,
    created_date
  ]);
  const columnList = [
    "id",
    "created_by",
    // "category",
    "sub_category",
    "status",
    "severity",
    "assigned_to",
    "created_date",
    "total_time"
  ];

  let tableHead = [
    {
      name: "Tic.No",
      sorting: true,
      value: "id",
    },
    {
      name: "Email",
      sorting: true,
      value: "created_by",
    },

    // {
    //   name: "Category",
    //   sorting: true,
    //   value: "category",
    // },

    {
      name: "Sub Category",
      sorting: true,
      value: "sub_category__name",
    },
    {
      name: "Status",
      sorting: true,
      value: "status",
    },
    {
      name: "Severity",
      sorting: true,
      value: "severity",
    },
    {
      name: "Assignee ",
      sorting: true,
      value: "assigned_to__name",
    },
    {
      name: "Created Date ",
      sorting: true,
      value: "created_date",
    },
    {
      name: "Time Log",
      sorting: false,
      value: "total_time",
    },
    {
      name: "Actions",
      sorting: false,
      value: "",
    },
  ];
  const handleClick = async (idx) => {
    Logger.debug("clciked ugkuyfyrdjyfj", idx);
    await axios
      .delete(`${BASE_URL}api/ticket/${idx}/`, {
        headers: { Authorization: `Bearer ${apiKey}` },
      })
      .then((res) => {
        setToaster(true);
        setTitle("Success");
        setSubTitle(`Ticket No. ${idx} has been deleted`);
        setTimeout(() => {
          setToaster(false);
        }, 2000);
      })
      .catch((error) => {
        if (error.response.status == 403) {
          cookies.remove("UserLogin");
          cookies.remove("UserDetails");
          cookies.remove("adminRole");
          cookies.remove("sysAdminRole");
          cookies.remove("createdBy");
          cookies.remove("UserLoginAccessToken");
          cookies.remove("UserName");
          navigate("/");
        }
        if (error.response.status == 404) {
          navigate("/*");
          setTimeout(() => {
            navigate("/secured/empDashboard");
          }, 5000);
        }
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  document.title = "Ticket List | ITSupport-Helpdesk";

  return (
    <>
      <div className="divcolor">
        <div className="mb-[15px] empMainHeader">
          <div className="headerLabel">Ticket List</div>
          <div className="date_input">
            <TextField
              id="outlined-basic"
              variant="outlined"
              // label="Select date"
              type={inputType}
              onFocus={() => setInputType("date")}
              onBlur={() => setInputType("text")}
              placeholder="Select date"
              size="small"
              style={{ width: "100%" }}
              InputProps={{
                inputProps: {
                  min: "1900-01-01",
                  max: maxDate,
                  placeholder: "Select date",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  "&::placeholder": {
                    fontSize: "14px",
                    fontFamily: "Arial, Helvetica, sans-serif !important",
                    opacity: 0.5,
                  },
                },
              }}
              onChange={(event) => {
                setCreated_date(event.target.value);
                Logger.info("date is", event.target.value);
              }}
            />
           
          </div>

          <div className="w-[460px]">
            <SearchContent
              placeholderText="Search by email, sub-category, status, severity, assignee name"
              onChange={(e) => {
                setSearchKey(e.target.value);
              }}
            />
          </div>
        </div>
        <TableList
          data={data}
          headerData={tableHead}
          column={columnList}
          actionIcons={["view", "assign", "delete"]}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          isAdmin={isAdmin}
          isSuperAdmin={isSuperAdmin}
          orderBy={sortBy}
          ordering={ordering}
          setUpdater={setUpdater}
          updater={updater}
          setOrdering={setOrdering}
          handleClick={handleClick}
          setSortedBy={(val) => {
            setSortBy(val);
          }}
          setSortedOrder={(val) => {
            setSortOrder(val);
          }}
          actionUrl={["/view", "/secured/assign"]}
          pageNumber={page}
          //planId={planId}
          serialNum={false}
        ></TableList>
        {fullPageData > 10 ? (
          <TablePagination
            component="div"
            count={fullPageData}
            page={page}
            onPageChange={handleChangePage}
            labelDisplayedRows={({ from, to, count }) => {
              // return `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`; 
              return `${count - from + 1}–${count - to + 1} of ${count !== -1 ? count : `more than ${to}`}`;

            }}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        ) : (
          <></>
        )}
        {toaster ? (
          <CustomToaster
            title={title}
            subTitle={subTitle}
            variant={variant}
          ></CustomToaster>
        ) : (
          <></>
        )}
        {open ? (
          <SimpleBackdrop open={open} setOpen={setOpen}></SimpleBackdrop>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default EmpTicketTable;
